import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
    {
        path: '/:locale(en|lt)?',
        component: () => import('./HomePage.vue'),
    },
    {
        path: '/:locale(en|lt)/blog',
        component: () => import('./pages/BlogLayout.vue'),
        children: [
            {
                path: '',
                name: 'blog-list',
                component: () => import('./pages/BlogList.vue'),
            },
            {
                path: ':slug',
                name: 'blog-post',
                component: () => import('./pages/BlogPost.vue'),
            },
        ],
    },
];
